function makeProductTagHint($elem, isMobile) {
  const $inner = $elem.find(".product-tags__elem-popup");

  const $popup = $(`
    <div class="product-tags__popup ${isMobile ? "product-tags__popup--mobile" : ""}">
      <div class="product-tags__popup-inner">
        ${
          isMobile
            ? `
          <button class='product-tags__popup-close'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group">
            <g id="Group_2">
            <path id="Path" d="M5 5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path id="Path_2" d="M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            </g>
            </svg>
          </button>
        `
            : ""
        }
        ${$inner.html()}
        <div class="product-tags__popup-tail"></div>
      </div>
    </div>
  `);

  return $popup;
}

function showTagHint($el) {
  const $popup = $(".product-tags__popup");

  $popup.removeClass("is--shown");

  setTimeout(function () {
    $popup.remove();
  }, 300);

  $("body").append($el);

  setTimeout(function () {
    $el.addClass("is--shown");
  }, 0);
}

function removeTagHint() {
  const $popup = $(".product-tags__popup");

  if ($popup.length > 1) {
    for (let i = 1; i < $popup.length; i++) {
      $popup.eq(i).removeClass("is--shown");

      setTimeout(function () {
        $popup.eq(i).remove();
      }, 300);
    }

    return;
  }

  $popup.removeClass("is--shown");

  setTimeout(function () {
    $popup.remove();
  }, 300);
}

const checkProductTagsSliderPosition = (el) => {
  const $slides = $(el).find(".swiper-slide");

  if ($slides.first().offset().left - $(el).offset().left < -5) {
    $(el).addClass("overflow-left");
  } else {
    $(el).removeClass("overflow-left");
  }

  // console.log(
  //   "###offset",
  //   $slides.last().offset().left + $slides.last().outerWidth() - ($(el).offset().left + $(el).outerWidth())
  // );

  if ($slides.last().offset().left + $slides.last().outerWidth() - ($(el).offset().left + $(el).outerWidth()) > 0) {
    $(el).addClass("overflow-right");
  } else {
    $(el).removeClass("overflow-right");
  }
};

const onProductTagsSliderMove = throttle(checkProductTagsSliderPosition, 500);

function initProductTagsSlider() {
  $(".product-tags__slider").each((idx, item) => {
    if ($(item).find(".product-tags__elem").length) {
      const productTags = new Swiper(item, {
        slidesPerView: "auto",
        touchMoveStopPropagation: true,
        navigation: {
          nextEl: $(item).parent().find(".product-tags__button--next").get(0),
          prevEl: $(item).parent().find(".product-tags__button--prev").get(0),
        },
        on: {
          init(swiper) {
            checkProductTagsSliderPosition(swiper.el);
          },
          setTranslate(swiper) {
            onProductTagsSliderMove(swiper.el);
            // console.log('###move', swiper.el);
          },
          transitionEnd(swiper) {
            // console.log("###end");
            checkProductTagsSliderPosition(swiper.el);
          },
        },
      });
    }

    if ($(item).parents(".catalog-list").length) {
      if ($(item).find(".product-tags__elem").length) {
        $(item).parents(".catalog-card").first().addClass("has-tags");
      }
    }
  });
}

initProductTagsSlider();

$(document).on("mouseenter", ".product-tags__elem", function (e) {
  if ($(window).outerWidth() < 768) return;

  if ($(this).parents(".product-tags__slider").get(0).swiper.animating) return;

  if ($(e.target).find(".product-tags__elem-popup").length) {
    const $container = $(".section .container").first();
    const elemOffsetLeft =
      $(e.target).offset().left + $(e.target).outerWidth() / 2 - ($(window).width() - $container.outerWidth()) / 2;
    const elemOffsetRight =
      $(window).width() -
      $(e.target).offset().left -
      $(e.target).outerWidth() / 2 -
      ($(window).width() - $container.outerWidth()) / 2;

    const $popup = makeProductTagHint($(e.target));

    if ($(e.target).parents(".product-tags__block").length) {
      $popup.addClass("is--main");
    }

    const top = $(e.target).parents(".product-tags__block").length
      ? `${$(e.target).offset().top + $(e.target).outerHeight() - $(window).scrollTop()}px`
      : `${$(e.target).offset().top - $(window).scrollTop()}px`;

    if (elemOffsetLeft < 145) {
      $popup.css({
        left: `${$(e.target).offset().left}px`,
        right: "auto",
        top,
        transform: $(e.target).parents(".product-tags__block").length ? "translateY(0)" : "translateY(-100%)",
      });

      $popup.find(".product-tags__popup-tail").css({
        left: `${$(e.target).outerWidth() / 2}px`,
      });
    } else if (elemOffsetRight < 145) {
      $popup.css({
        right: `${$(window).width() - $(e.target).offset().left - $(e.target).outerWidth()}px`,
        left: "auto",
        top,
        transform: $(e.target).parents(".product-tags__block").length ? "translateY(0)" : "translateY(-100%)",
      });

      $popup.find(".product-tags__popup-tail").css({
        right: `${$(e.target).outerWidth() / 2}px`,
        transform: $popup.hasClass("is--main") ? "translateX(50%) rotate(180deg)" : "translateX(50%)",
      });
    } else {
      $popup.css({
        left: `${$(e.target).offset().left + $(e.target).outerWidth() / 2}px`,
        right: "auto",
        top,
        transform: $(e.target).parents(".product-tags__block").length ? "translate(-50%)" : "translate(-50%, -100%)",
      });

      $popup.find(".product-tags__popup-tail").css({
        left: "50%",
      });
    }

    // $('body').append($popup);
    showTagHint($popup);
  }
});

$(document).on("mouseleave", ".product-tags__elem", function (e) {
  if ($(window).outerWidth() < 768) return;

  if (e.relatedTarget.classList.contains("product-tags__popup")) {
    return;
  }
  // $('.product-tags__popup').remove();
  removeTagHint();
});

$(document).on("mouseleave", ".product-tags__popup", function () {
  if ($(window).outerWidth() < 768) return;

  removeTagHint();
});

$(window).on("scroll", function () {
  if ($(window).outerWidth() < 768) return;

  $(".product-tags__popup").remove();
});

$(document).on("click", ".product-tags__elem", function (e) {
  if ($(window).outerWidth() > 767) return;
  e.preventDefault();

  const $popup = makeProductTagHint($(e.target), true);

  $("body").append($popup);

  setTimeout(function () {
    $popup.addClass("is--shown");
    $("body").addClass("modal-open");
  }, 0);
});

$(document).on("click", ".product-tags__popup-close", function (e) {
  const $popup = $(e.target).parents(".product-tags__popup").first();

  $popup.removeClass("is--shown");

  setTimeout(function () {
    $popup.remove();
    $("body").removeClass("modal-open");
  }, 300);
});

$(document).on("click", ".product-tags__popup--mobile", function (e) {
  if ($(e.target).closest(".product-tags__popup-inner").length) return;

  $(e.currentTarget).removeClass("is--shown");

  setTimeout(function () {
    $(e.currentTarget).remove();
    $("body").removeClass("modal-open");
  }, 300);
});

const productPreview = $(`
  <div class="product-preview">
    <img src="${$(".product-thumbs .swiper-slide").first().find("img").attr("src")}">
  </div>
`);

$(".product-sliders").prepend(productPreview);

const stopVideo = (element) => {
  if (!element.length) return;

  const iframe = element.find("iframe");
  const video = element.find("video");
  if (iframe.length) {
    const iframeSrc = iframe.attr("src");
    iframe.attr("src", iframeSrc);
  }
  if (video.length) {
    video[0].pause();
  }
};

const mainProductSliderAnimation = new ProductSliderAnimation(".product-preview .product-slider__animation");
const modalProductSliderAnimation = new ProductSliderAnimation(".gallery-modal__animation-control");
const mobileMainProductSliderAnimation = new ProductSliderAnimation();
// let productSliderInterval;
// let productSliderAnimationIndex = 0;

// function startProductAnimation() {
//   if (productSliderInterval) {
//     clearInterval(productSliderInterval);
//     productSliderInterval = null;
//   }

//   const images = $('.product-preview .product-slider__animation img');

//   productSliderInterval = setInterval(function() {
//     console.log('###timer', productSliderAnimationIndex);
//     images.hide();
//     images.eq(productSliderAnimationIndex).show();

//     if (productSliderAnimationIndex >= images.length - 1) {
//       productSliderAnimationIndex = 0;
//     } else {
//       productSliderAnimationIndex++;
//     }
//   }, 100)
// }

// function stopProductAnimation() {
//   clearInterval(productSliderInterval)
//   productSliderInterval = null;
// }

function onThumbsSlideChange(swiper) {
  const activeSlide = $(".product-slider .swiper-slide").eq(swiper.activeIndex);
  const html = activeSlide.html();

  productPreview.html(html);

  if (activeSlide.hasClass("swiper-slide--3d")) {
    productPreview.find("img").first().css({ display: "inline" });
    productPreview.addClass("is--3d-view");
    // productSliderAnimationIndex = 0;
    mainProductSliderAnimation.initImages(".product-preview .product-slider__animation img");
    mainProductSliderAnimation.reset();
    // startProductAnimation();
    mainProductSliderAnimation.start();
  } else {
    productPreview.removeClass("is--3d-view");
    // productSliderInterval && stopProductAnimation();
    mainProductSliderAnimation.stop();
  }

  if (!activeSlide.hasClass("swiper-slide--video")) {
    // console.log("NOT video");
    stopVideo($(".product-slider .product-slider__video"));
  }
}

if ($(".product-slider").length && $(".product-thumbs").length) {
  let sliderInit = setInterval(function () {
    if ($(".product-slider")[0].swiper && $(".product-thumbs")[0].swiper) {
      // console.log("###slider success");
      clearInterval(sliderInit);

      $(".slider-module").addClass("is--loaded");

      let thumbsSlider = $(".product-thumbs")[0].swiper;
      let productSlider = $(".product-slider")[0].swiper;

      productSlider.on("slideChange", function (swiper) {
        onThumbsSlideChange(swiper);

        if ($(window).outerWidth() < 768 && swiper.slides[swiper.activeIndex].classList.contains("swiper-slide--3d")) {
          mobileMainProductSliderAnimation.start();
        }
      });

      if (thumbsSlider && $(".slider-module").hasClass("has-video-block")) {
        thumbsSlider.destroy();
        productSlider.destroy();

        thumbsSlider = new Swiper(".product-thumbs", {
          spaceBetween: 15,
          slidesPerView: "auto",
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        productSlider = new Swiper(".product-slider", {
          slidesPerView: 1,
          spaceBetween: 10,
          nested: true,
          visibilityFullFit: true,
          thumbs: {
            swiper: thumbsSlider,
            multipleActiveThumbs: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          on: {
            slideChange(swiper) {
              onThumbsSlideChange(swiper);

              if (
                $(window).outerWidth() < 768 &&
                swiper.slides[swiper.activeIndex].classList.contains("swiper-slide--3d")
              ) {
                mobileMainProductSliderAnimation.start();
              }
            },
          },
        });
      }

      mobileMainProductSliderAnimation.initImages(".product-slider .product-slider__animation img");

      function initGalleryModalSliders() {
        const slidesHtml = $(".product-slider .swiper-slide")
          .map(function () {
            const additionalClass = $(this).hasClass("swiper-slide--3d")
              ? "swiper-slide--3d"
              : $(this).hasClass("swiper-slide--video")
              ? "swiper-slide--video"
              : "";
            return `<div class="swiper-slide ${additionalClass}">${$(this).html()}</div>`;
          })
          .get()
          .reduce((prev, next) => prev + next, "");

        const videoButton = $(".product-thumbs__video-button");

        const thumbsHtml = $(".product-slider .swiper-slide")
          .map(function () {
            if ($(this).hasClass("swiper-slide--3d")) {
              return `
            <div class="swiper-slide">
              <div class="product-thumbs__icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Interface, Essential/3d, &#208;&#161;ube, Sphere">
                <g id="Group">
                <g id="Group_2">
                <path id="Path" fill-rule="evenodd" clip-rule="evenodd" d="M2 24.2951V14.9578C2 11.8167 3.67059 8.91274 6.38431 7.33235L15.2078 2.19706C17.951 0.60098 21.3412 0.60098 24.0843 2.19706L32.9078 7.33235C35.6235 8.91274 37.2941 11.8167 37.2941 14.9578V24.2951C37.2941 27.4363 35.6235 30.3402 32.9098 31.9206L24.0863 37.0559C21.3431 38.652 17.9529 38.652 15.2098 37.0559L6.38627 31.9206C3.67059 30.3402 2 27.4363 2 24.2951Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Path_2" d="M12.4531 16.98C12.7649 15.9016 13.7178 15.0977 14.8963 15.0977C16.3237 15.0977 17.4825 16.2545 17.4825 17.6839C17.4825 18.9624 16.4453 19.9996 15.1669 19.9996C16.4453 19.9996 17.4825 21.0369 17.4825 22.3153C17.4825 23.7428 16.3257 24.9016 14.8963 24.9016C13.7178 24.9016 12.7649 24.0977 12.4531 23.0192" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Path_3" fill-rule="evenodd" clip-rule="evenodd" d="M24.2901 24.9016H21.5273V15.0977H24.2901C26.3744 15.0977 28.0646 16.7879 28.0646 18.8722V21.129C28.0626 23.2114 26.3744 24.9016 24.2901 24.9016V24.9016Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                </g>
                </g>
                </svg>
              </div>
            </div>
          `;
            }

            if ($(this).hasClass("swiper-slide--video")) {
              return "";
            }

            return `<div class="swiper-slide">${$(this).html()}</div>`;
          })
          .get()
          .reduce((prev, next) => prev + next, "");

        const galleryModal = $(`
        <div class="gallery-modal">
          <button class="gallery-modal__close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group">
            <g id="Group_2">
            <path id="Path" d="M5 5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path id="Path_2" d="M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            </g>
            </svg>
          </button>
          <div class="gallery-modal__body">
            <div class="gallery-modal__main-slider-block">
              <div class="gallery-modal__main-slider swiper">
                <div class="gallery-modal__main-slider-wrapper swiper-wrapper">
                  ${slidesHtml}
                </div>
              </div>
              <div class="gallery-modal__main-slider-controls">
                <div class="gallery-modal__main-slider-controls-container container">
                  <button class="gallery-modal__main-slider-prev">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="Group">
                      <g id="Group_2">
                      <path id="Path" d="M10 24H38" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      <path id="Path_2" d="M20 14L10 24" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      <path id="Path_3" d="M20 34L10 24" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      </g>
                    </svg>
                  </button>
                  <button class="gallery-modal__main-slider-next">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="Group">
                      <g id="Group_2">
                      <path id="Path" d="M10 24H38" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      <path id="Path_2" d="M20 14L10 24" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      <path id="Path_3" d="M20 34L10 24" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="gallery-modal__animation-control"></div>
              <div class="gallery-modal__pagination swiper-pagination"></div>
            </div>
          </div>
          <div class="gallery-modal__bottom">
            <button class="gallery-modal__thumbs-prev">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Group">
                <path id="Path" d="M14 8L10 12L14 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
            </button>
            <div class="gallery-modal__thumbs">
              <div class="gallery-modal__thumbs-slider swiper">
                <div class="gallery-modal__thumbs-slider-wrapper swiper-wrapper">
                  ${thumbsHtml}
                </div>
              </div>
            </div>
            <button class="gallery-modal__thumbs-next">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Group">
                <path id="Path" d="M14 8L10 12L14 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
            </button>
            ${videoButton.length ? videoButton.clone().wrap("<p/>").parent().html() : ""}
          </div>
        </div>
      `);

        $("body").append(galleryModal);

        galleryModal.find(".product-slider__animation img").first().css({ display: "inline" });

        const galleryModalThumbsSlider = new Swiper(".gallery-modal__thumbs-slider", {
          slidesPerView: "auto",
          navigation: {
            nextEl: ".gallery-modal__thumbs-next",
            prevEl: ".gallery-modal__thumbs-prev",
          },
        });

        const galleryModalMainSlider = new Swiper(".gallery-modal__main-slider", {
          slidesPerView: "auto",
          navigation: {
            prevEl: ".gallery-modal__main-slider-prev",
            nextEl: ".gallery-modal__main-slider-next",
          },
          thumbs: {
            swiper: galleryModalThumbsSlider,
          },
          pagination: {
            el: ".gallery-modal__pagination",
          },
          on: {
            slideChange(swiper) {
              if (swiper.slides[swiper.activeIndex].classList.contains("swiper-slide--3d")) {
                modalProductSliderAnimation.start();

                $(".gallery-modal__animation-control").show();
              } else {
                modalProductSliderAnimation.stop();
                $(".gallery-modal__animation-control").hide();
              }

              if (!swiper.slides[swiper.activeIndex].classList.contains("swiper-slide--video")) {
                stopVideo($(".gallery-modal__main-slider .product-slider__video"));
              }
            },
          },
        });

        return {
          main: galleryModalMainSlider,
          thumbs: galleryModalThumbsSlider,
        };
      }

      const galleryModalSliders = initGalleryModalSliders();
      modalProductSliderAnimation.initImages(".gallery-modal__main-slider-block .product-slider__animation img");

      $(".product-slider .swiper-slide").removeAttr("href").removeAttr("data-fancybox");

      $(document).on("click", ".product-preview", function () {
        if ($(this).hasClass("is--moved")) return;

        galleryModalSliders.main.slideTo(productSlider.activeIndex, 0);
        galleryModalSliders.thumbs.slideTo(productSlider.activeIndex, 0);
        if (
          galleryModalSliders.main.slides[galleryModalSliders.main.activeIndex].classList.contains(
            "swiper-slide--3d"
          ) &&
          !modalProductSliderAnimation.interval
        ) {
          modalProductSliderAnimation.start();
        }
        $(".gallery-modal").addClass("is--opened");
        $("body").addClass("modal-open");
      });

      $(document).on("click", ".product-slider .swiper-slide", function () {
        galleryModalSliders.main.slideTo(productSlider.activeIndex, 0);
        if (
          galleryModalSliders.main.slides[galleryModalSliders.main.activeIndex].classList.contains(
            "swiper-slide--3d"
          ) &&
          !modalProductSliderAnimation.interval
        ) {
          modalProductSliderAnimation.start();
        }
        $(".gallery-modal").addClass("is--opened");
        $("body").addClass("modal-open");
      });

      $(document).on("click", ".gallery-modal__close", function () {
        $(".gallery-modal").removeClass("is--opened");
        $("body").removeClass("modal-open");
        modalProductSliderAnimation.stop();
      });

      $(document).on("click", ".gallery-modal .product-thumbs__video-button", function () {
        galleryModalSliders.main.slideTo($(".gallery-modal__main-slider .swiper-slide").length - 1);
        galleryModalSliders.thumbs.slideTo($(".gallery-modal__thumbs-slider .swiper-slide").length - 1);
      });

      $(document).on("click", ".product-sliders .product-thumbs__video-button", function () {
        galleryModalSliders.main.slideTo($(".gallery-modal__main-slider .swiper-slide").length - 1, 0);
        galleryModalSliders.thumbs.slideTo($(".gallery-modal__thumbs-slider .swiper-slide").length - 1, 0);
        $(".gallery-modal").addClass("is--opened");
        $("body").addClass("modal-open");
      });

      // $(document).on('mousedown', '.product-slider__animation', function(e) {
      //   // const images = $('.product-preview .product-slider__animation img');

      //   e.preventDefault();
      //   $(this).parent().removeClass('is--moved');
      //   let moved = false;
      //   let x = e.clientX;
      //   let delta = 0;

      //   function onMouseMove(event) {
      //     let move = Math.round((event.clientX - x) / 10);

      //     // console.log(move, delta);

      //     if (move < delta) {
      //       // console.log('####turn left', productSliderAnimationIndex);
      //       // productSliderAnimationIndex = productSliderAnimationIndex > 0 ? productSliderAnimationIndex - 1 : images.length - 1;
      //       // console.log('####turn left', productSliderAnimationIndex);

      //       // images.hide();
      //       // images.eq(productSliderAnimationIndex).show();
      //       mainProductSliderAnimation.move('left');

      //       delta = move;
      //     } else if (move > delta) {
      //       console.log('####turn right');
      //       // productSliderAnimationIndex = productSliderAnimationIndex < images.length - 1 ? productSliderAnimationIndex + 1 : 0;

      //       // images.hide();
      //       // images.eq(productSliderAnimationIndex).show();

      //       mainProductSliderAnimation.move('right');

      //       delta = move;
      //     }

      //     moved = true;
      //     $(this).parent().addClass('is--moved');
      //   }

      //   $(this).on('mousemove', onMouseMove);

      //   $(this).on('mouseup', () => {
      //     console.log('######upppppppppppppppppp');
      //     $(this).off('mousemove', onMouseMove);
      //     // startProductAnimation();
      //     mainProductSliderAnimation.start();
      //   })

      //   // stopProductAnimation();
      //   mainProductSliderAnimation.stop();
      // })
    } else {
      // console.log("###slider failed");
    }
  }, 10);
}

$(window).on("load", function () {
  $(".product-slider").addClass("is--loaded");
});
